import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';

// Layouts
import Layout3 from './website/1_home3/Layout';
import AboutLayout from './website/2_about/AboutLayout';
import ContactLayout from './website/6_Contact/ContactLayout';
import CareerLayout from './website/5_Career/CareerLayout';
import EventLayout from './website/4_Events/EventLayout';
import RegistrationLayout from './website/0_Registration/RegistrationLayout';
import { BookLayout } from './website/0_Book1/A_BookLayout';
import { LoginPage } from './website/7_Login/LoginPage';
// import { ProtectedRoute } from './website/7_Login/1_Admin/ProtectedRoutes';

// Offerings
import TeachersOfferings from './website/3_Offerings/TeacherOfferingLayout';
import SchoolsOfferings from './website/3_Offerings/SchoolsOfferingsLayout';
//import StudentsCBSEOfferings from './website/3_Offerings/StudentsCBSELayout';
//import StudentsCodingOfferings from './website/3_Offerings/StudentsCodingLayout';
import CourseDetails from './website/3_Offerings/CourseDetails';
import OfferingLayout from './website/1_home2/OfferingLayout';

// Career & Jobs
import JobDetails from './website/5_Career/JobDetails';

// Blog
import BlogDisplay from './website/1_home2/Blogs';
import BlogDetails from './website/1_home2/BlogDetails';

// Events
import Events from './website/1_home2/Events';
import AddEvents from './website/Admin_Pages/AddEvents';
import UpdateEvents from './website/Admin_Pages/UpdateEvents';
import EventPage from './website/1_home2/EventPage';
import ArchivePage from './website/1_home2/ArchivePage';
import ArchiveEventsPage from './website/1_home2/ArchiveEventsPage';
import ArchiveEventDetailsPage from './website/1_home2/ArchiveEventDetailsPage';

// Registration
import RegistrationForm from './website/0_Registration/Registration';
import Offerings from './website/1_home2/Offerings'
// Admin Side Routes 
// Folder Management
import { FolderSection } from './website/Folder/FolderSection';

// CRUD Operations
import YearManagement from './website/0_Book1/E_YearManagement';
import MonthManagement from './website/0_Book1/F_MonthManagement';

// Admin Pages
import DashboardPage from './website/Admin_Pages/AdminHomepage';
import CreateCoursePage from './website/Admin_Pages/Create_Course';
import ChangeBookOrder from './website/Admin_Pages/ChangeBookOrder';
import AddBooks from './website/Admin_Pages/AddBooks';
import EditBooks from './website/Admin_Pages/EditBooks';
import EditSchools from './website/Admin_Pages/EditSchools';
import AddTestimonials from './website/Admin_Pages/AddTestimonials';
import EditTestimonials from './website/Admin_Pages/EditTestimonials';
import AddBlogs from './website/Admin_Pages/Blogs/AddBlogs';
import AddNews from './website/Admin_Pages/Blogs/AddNews'
import UpdateBlogs from './website/Admin_Pages/Blogs/UpdateBlogs';
import UpdateNews from './website/Admin_Pages/Blogs/UpdateNews';
import CreateArticle from './website/1_home3/CreateArticle'
import CreateNews from './website/1_home3/CreateNews'

// Customers
import Customers from './Customers/Customers';
import AddCustomer from './Customers/AddCustomer';
import DeleteCustomers from './Customers/DeleteCustomers';
import MergeCustomers from './Customers/MergeCustomers';
import MergeId from './Customers/MergeId';
import Trash from './Customers/Trash';
import Comments from './website/Admin_Pages/Comments'

// Login
import CRMLogin from './website/7_Login/CRMLogin';

// Test Component
import { Test } from './website/0_layout/Test1';
import EnquiryTable from './website/Admin_Pages/Enquiries';
// import AdminLayout from './website/Dashboard/dashboard';
import AdminLayout from './website/Admin_Pages/Admin_Layout/AdminLayout';
import { ProtectedRoute } from './website/Admin_Pages/ProtectedRoute';
import BooksForm from './website/1_home2/BooksForm'
import RecentContacts from './Customers/RecentContacts';
import CsvUploader from './Customers/New/csvUploader';
import RawContactEditor from './Customers/New/rawContactEditor';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' >
      {/* ----- Within Base Routes ------ */}
      {/* <Route path='' element={<Layout/>} >    </Route>    */}
      <Route path='' element={<Layout3/>} />
      <Route path='/home3' element={<Layout3></Layout3>}/>
      <Route path='/customers' element={<Customers/>}/>
      <Route path='/customers/add-customer' element={<AddCustomer/>}/>
      <Route path='/customers/update-customer/specific' element={<AddCustomer/>}/>
      <Route path='/customers/delete-customer' element={<DeleteCustomers/>}/>
      <Route path='/customers/merge-customer' element={<MergeCustomers/>}/>
      <Route path='/customers/mergeId/:id' element={<MergeId/>}/>
      <Route path='/customers/trash' element={<Trash/>}/>
      <Route path='/customers/recents' element={<RecentContacts/>}/>

      <Route path='/crm' element={<CRMLogin></CRMLogin>}/>
      
      <Route path='/testing' element={<Test/>} />   
      <Route path='/home' element={<Layout3/>} />


        {/* New Routes */}
        <Route path='/customers/csv-uploader' element={ <CsvUploader/> }/>
        <Route path='/customers/raw-contact-editor' element={ <RawContactEditor/> }  />

      {/*<Route path='/offerings' element={<Layout3/>} />*/}


      <Route path='/about' element={<AboutLayout/>} />
      <Route path='/blogs' element={<BlogDisplay></BlogDisplay>} />
      <Route path="/blog/:id" element={<BlogDetails />} />
      <Route path='/blog/create' element={<CreateArticle />}/>
      <Route path='/news/create' element={<CreateNews />}/>
      <Route path="/news/:id" element={<BlogDetails />} />




      <Route path='/offerings/books/:book' element={<Offerings></Offerings>}/>
       <Route path="/offerings" element={<OfferingLayout />} />
      <Route path='/offerings/books/enquire/:index' element={<BooksForm></BooksForm>}/>       
      <Route path='/offerings/teachers' element={<TeachersOfferings/>} />
      <Route path='/offerings/schools' element={<SchoolsOfferings/>} />
      {/* <Route path='/offerings/students/coding' element={<StudentscodingOfferings/>} />
      <Route path='/offerings/students/cbse-subjects' element={<StudentscbseOfferings/>} /> */}
      <Route path='/courses-details/:coursesid' element={<CourseDetails/>} />
      <Route path='/registration' element={<RegistrationLayout />}>
        <Route path=':coursesid' element={<RegistrationForm />} />
      </Route>
      <Route path='events' element={<EventLayout/>} />
      <Route path="/events" element={<Events />} />
      <Route path="/" element={<Events multiple={true} />} />
      <Route path="/events/:eventType" element={<EventPage />}
  errorElement={<div>Oops! Event not found.</div>}
/>
      <Route path="/event-details/:eventType" element={<EventPage />} />
      <Route path="/archive" element={<ArchivePage />} />
      <Route path="/archive/:eventType" element={<ArchiveEventsPage />} />
      <Route path="/archieve-event-details" element={<ArchiveEventDetailsPage />} />

      <Route path='career' element={<CareerLayout />} />
      <Route path='career/:jobrole' element={<JobDetails />} />
      <Route path='contact' element={<ContactLayout />} />
      <Route path='book' element={<BookLayout />} />
      <Route path='crud/year' element={<YearManagement />} />
      <Route path='crud/month' element={<MonthManagement />} />
      <Route path='folder' element={<FolderSection />} />
      <Route path='login' element={<LoginPage />} />

      {/* Protected Admin Routes */}
      <Route element={<ProtectedRoute role={'admin'}/>}>
        <Route path='admin-dashboard' element={<DashboardPage />} />
        <Route path='admin-dashboard/create-courses' element={<CreateCoursePage />} />
        <Route path='admin-dashboard/edit-courses/order' element={<ChangeBookOrder />} />
        <Route path='admin-dashboard/edit-books/add-books' element={<AddBooks />} />
        <Route path='admin-dashboard/edit-books/update-books' element={<EditBooks />} />
        <Route path='admin-dashboard/edit-schools' element={<EditSchools />} />
        <Route path='admin-dashboard/edit-events' element={<AddEvents />} />
        <Route path='admin-dashboard/edit-news' element={<AddNews />} />

        <Route path='admin-dashboard/update-events' element={<UpdateEvents />} />
        <Route path='admin-dashboard/edit-testimonials/add-testimonials' element={<AddTestimonials />} />
        <Route path='admin-dashboard/edit-testimonials/update-testimonials' element={<EditTestimonials />} />
        <Route path='admin-dashboard/edit-testimonials/update-testimonials/specific' element={<AddTestimonials />} />
        <Route path='admin-dashboard/manage-blogs/add-blogs' element={<AddBlogs />} />
        <Route path='admin-dashboard/manage-blogs/add-news' element={<AddNews />} />
        <Route path='admin-dashboard/manage-blogs/update-blogs' element={<UpdateBlogs />} />
        <Route path='admin-dashboard/manage-blogs/update-news' element={<UpdateNews />} />
        <Route path='admin-dashboard/manage-blogs/update-blog/specific' element={<AddBlogs />} />
        <Route path='admin-dashboard/manage-blogs/update-news/specific' element={<AddNews />} />
        <Route path='/admin-dashboard/edit-books/update-books/specific' element={<AddBooks></AddBooks>}/>
        <Route path='/admin-dashboard/edit-courses/carousel-cards' element={<ChangeBookOrder></ChangeBookOrder>}/>
        <Route path='admin-dashboard/enquiries' element={<EnquiryTable></EnquiryTable>} />
        <Route path='admin-dashboard/comments' element={<Comments></Comments>} />
      </Route>

      <Route element={<ProtectedRoute role={'user'} />}>
        <Route path='/user-dashboard' element={<AdminLayout role='user'></AdminLayout>}/>
        <Route path='/user-dashboard/manage-blogs/add-blogs' element={<CreateArticle />}/>
        <Route path='/user-dashboard/manage-blogs/add-news' element={<CreateNews />}/>
        <Route path='/user-dashboard/manage-blogs/update-blogs' element={<UpdateBlogs role='user' />}/>
        <Route path='/user-dashboard/manage-blogs/update-news' element={<UpdateNews role='user' />}/>
        <Route path='/user-dashboard/manage-blogs/update-blog/specific' element={<CreateArticle/>}/>
        <Route path='/user-dashboard/manage-blogs/update-news/specific' element={<CreateNews/>}/>
      </Route>

    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode> 
);

reportWebVitals();
